import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {getTalentsSaga} from "./handler";

export default function* watchProTips() {
    yield takeLatest(types.GET_TALENTS, getTalentsSaga);
}
